<script>
	export let menuMobile = false;
	export let menuDropdown = false;
	import {User} from '../../models/user';
	import UserMenu from './header/UserMenu.svelte';
	import Project from '../../models/project';
	import MediaQuery from "svelte-media-query";

	let user = User.getUser();

	function scrollIntoView({ target }) {
		const el = document.querySelector(target.getAttribute('href'));
		if (!el) return;
    el.scrollIntoView({
      behavior: 'smooth'
    });
  }
	// console.log($user.Name)
</script>
<svelte:head>
	{#if menuMobile}
		<style>
			body {
				overflow: hidden;
			}
		</style>
	{/if}
</svelte:head>
<header>
	<div class="row no-gutters">
		<button class="menu-btn" class:open="{menuMobile}" on:click={()=>{ menuMobile = !menuMobile; return false; }}>
			<svg width=32 height=24>
				<line id="top" x1=0 y1=2  x2=32 y2=2/>
				<line id="middle" x1=0 y1=12 x2=32 y2=12/>
				<line id="bottom" x1=0 y1=22 x2=32 y2=22/>
			</svg>
		</button>
		<div class="col-lg-1 col-sm-12 col-xs-12">
			<a href="/" class="brand-logo">
				<img src="/images/conquest-logo.png" alt="Logo">
			</a>
		</div>
		<div class="col-lg-11 col-sm-12 col-xs-12 menu-sec">
			<div class="menu-block" class:menuopen="{menuMobile}">
				<ul class="menu">
					{#if !$Project.comingsoonOpen}
					<MediaQuery query="(max-width: 768px)" let:matches>
						{#if matches}
							<li>
								<a href="/">
									Home
								</a>
							</li>
							
							<li>
								<a href="#videos" on:click|preventDefault={scrollIntoView} on:click={()=>{ menuMobile = !menuMobile; return false; }}>
									Videos
								</a>
							</li>
							<li>
								<a href="#format" on:click|preventDefault={scrollIntoView} on:click={()=>{ menuMobile = !menuMobile; return false; }}>
									Format
								</a>
							</li>
							<!-- <li>
								<a href="/leaderboard">
									Leaderboard
								</a>
							</li>  -->
							<!-- <li>
								<a href="/rulebook.pdf" target="_blank" on:click={()=>{ menuMobile = !menuMobile; return false; }}>
									Rulebook
								</a>
							</li> -->
							<!-- <li>
								<a href="/schedule">
									Schedule
								</a>
							</li> -->
							<!-- <li>
								<a href="/team/624192bf4ee337f7c83c2d9d">
									Teams
								</a>
							</li> -->
							<!--
							<li>
								<a href="/videos">
									Videos
								</a>
							</li>  -->
							<!-- <li>
								<a href="#">
									Contests
								</a>
							</li> -->
							<!-- <li>
								<a href="/faqs">
									FAQs
								</a>
							</li> -->
							{:else}
							<li>
								<a href="/">
									Home
								</a>
							</li>
							
							<li>
								<a href="#videos" on:click|preventDefault={scrollIntoView}>
									Videos
								</a>
							</li>
							<li>
								<a href="#format" on:click|preventDefault={scrollIntoView}>
									Format
								</a>
							</li>
							<!-- <li>
								<a href="/leaderboard">
									Leaderboard
								</a>
							</li>  -->
							<!-- <li>
								<a href="/rulebook.pdf" target="_blank">
									Rulebook
								</a>
							</li> -->
							<!-- <li>
								<a href="/schedule">
									Schedule
								</a>
							</li> -->
							<!-- <li>
								<a href="/team/624192bf4ee337f7c83c2d9d">
									Teams
								</a>
							</li> -->
							<!--
							<li>
								<a href="/videos">
									Videos
								</a>
							</li>  -->
							<!-- <li>
								<a href="#">
									Contests
								</a>
							</li> -->
							<!-- <li>
								<a href="/faqs">
									FAQs
								</a>
							</li> -->
						{/if}
					</MediaQuery>
						
						{:else}
							<li>
								<a href="/">
									Home
								</a>
							</li>
						{/if}
				</ul>
				<div class="profile-icon">
					{#if menuMobile}
						{#if !$Project.comingsoonOpen}
							{#if !$user.loggedOut}
								<a href="#" class="profile-btn" class:active={!$user.loggedOut} on:click={()=>{ menuDropdown = !menuDropdown; return false; }}>
									{#if !$user.loggedOut}
									<strong>
										Hi, {$user.Name}
									</strong>
										<span class="nav-profile-icon">
											{#if $user.Photo}
												<img class="pic" src={$user.Photo.url} align="Profile-pic" alt="">
												{:else}
												<div class="content uppercase"> {$user.Name.indexOf(' ') != -1 ? $user.Name.split(' ').map(a => a[0]).join('').substr(0,2) : $user.Name.substr(0,2)} </div>
											{/if}
										</span>
									{:else}
										{$Project.registrationsOpen ? 'Sign in / Register': 'Login '}
										<span class="material-icons">
											person
										</span>
									{#if $Project.registrationsOpen}
										Sign in / Register
										<span class="material-icons">
											person
										</span>
									{:else}
										Login / Go to Dashboard
										<span class="material-icons">
											person
										</span>
									{/if}
										
									{/if}
								</a>
								{:else}
									<a href="/login" class="profile-btn">
										<strong>
											{$Project.registrationsOpen ? 'Sign in / Register': 'Login'}
										</strong>
										<span class="material-icons">
											person
										</span>
									</a>
								{/if}
								{:else}
								<span></span>
						{/if}
					{:else}
					{#if !$Project.comingsoonOpen}
						<a href="#" class="profile-btn" class:active={!$user.loggedOut} on:click={()=>{ menuDropdown = !menuDropdown; return false; }}>
							{#if !$user.loggedOut}
							<strong> Hi, {$user.Name}</strong>
								<span class="nav-profile-icon">
									{#if $user.Photo}
										<img class="pic" src={$user.Photo.url} align="Profile-pic" alt="">
										{:else}
										{#if $user.Name == undefined}
											<span class="material-icons">
												person
											</span>
											{:else}
											<div class="content uppercase"> {$user.Name.indexOf(' ') != -1 ? $user.Name.split(' ').map(a => a[0]).join('').substr(0,2) : $user.Name.substr(0,2)} </div>
										{/if}
									{/if}
									
								</span>
							{:else}
							<strong> {$Project.registrationsOpen ? 'Sign in / Register': 'Login '}</strong>
								<span class="material-icons">
									person
								</span>
							{/if}
						</a>
						{:else}
						<span class="hidden-person">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						{/if}
					{/if}
					{#if menuDropdown}
						{#if $user.loggedOut}
							<div class="menu-dropdown">
								<!-- <p class="login-txt">
									Login in to your account.
								</p> -->
								<ul>
									<li>
										<a href="/login" class="">
											Log in
										</a>
									</li>
								</ul>
								<!-- <p class="dnt-have-acnt-txt">
									Dont have an account? <a href="/login">Create one</a>
								</p> -->
							</div>
						{:else}
							<div class="menu-dropdown">
								<ul>
									<li>
										<a href="/" on:click={e => {
												User.logout();
											}}>
											Logout
										</a>
									</li>
								</ul>
							</div>
						{/if}
						<UserMenu onClose={() => { menuDropdown = false }}/>
					{/if}
				</div>
			</div>
		</div>
		<!-- <div class="col-lg-1 col-sm-1 col-xs-1 text-right">
		</div> -->
	</div>
</header>

<style>
</style>